import { ReactComponent as ProtocolIcon } from "./assets/protocol.svg"
import { ReactComponent as MeetTheTeams } from "./assets/meetTheTeam.svg"
import { ReactComponent as DailyOperations } from "./assets/dailyOperations.svg"


// import { ReactComponent as MeetTeams } from "./assets/teams.svg"
// import { ReactComponent as DailyOps } from "./assets/daily-ops.svg"
// import { ReactComponent as ActiveProtocolIcon } from "./assets/active-protocol.svg"
// import { ReactComponent as ActiveMeetTeams } from "./assets/active-teams.svg"
// import { ReactComponent as ActiveDailyOps } from "./assets/active-daily-ops.svg"
import { ReactComponent as OnBoarding } from "./assets/onboardingStage.svg"
import { ReactComponent as Project } from "./assets/projectExecution.svg"
import { ReactComponent as Bidding } from "./assets/biddingStage.svg"
import { ReactComponent as Outreach } from "./assets/prospecting.svg"
import { ROUTES } from "../../config/routes";

export const teamsContent = [
  {
    title: "Knowledge Team",
    mail: "KT@jaspercolin.com",
    
    content: ["The knowledge team is an extended sales support team which works round the clock and is responsible to supply intelligence on prospects. They help with identifying relevant prospects, supply pitch decks, collaterals, Decision maker details etc.", "​This team is also responsible for connecting you with industry experts whenever you need their assistance to lead the client call or get some information."]
  },
  {
    title: "Pre-sales Team",
    mail: "presales@jaspercolin.com​",
    content: ["The Pre-sales team helps in drafting proposals and helping with quotations. They help with SOWs but the pricing is taken care by the Sales team. They must always be kept away from pricing discussions. ​"]
  },
  {
    title: "Finance Team",
    mail: "finance@jaspercolin.com​",
    content: ["For any confirmation related to client onboarding, payments received etc, write directly to Finance team and they will revert.","Finance Manager- vikas.jha@jaspercolin.com​"]
  },
  {
    title: "Client Services Team",
    mail: "",
    content: ["Every project won will be handed over to the CS/ PM team after confirming with Amit."," All pricing details must be removed from the email chain and the project must be entered to the “Connect tool”."]
  },
  
]

export const standardProtocolContent = [
  "Everything worked upon must be kept on SharePoint​.",
  "Client Name and details to not be revealed to anybody internally in the organization without approval.​",
  "Pricing details not to be revealed to CS/PM teams​.",
  "Be mindful of the time/ deadlines.​",
  " Every email from the client should be acknowledged/ replied within 10-15 minutes.​"
]


export const InternalRoutes = [
  // {
  //   link: ROUTES.STANDARD_PROTOCOL,
  //   icon: <ProtocolIcon  />,
  //   text: "Standard Protocol",
  //   // activeIcon: <ActiveProtocolIcon />
  // },
  {
    link: ROUTES.MEET_THE_TEAMS,
    icon: <MeetTheTeams />,
    text: "Meet the teams",
    // activeIcon: <ActiveMeetTeams />
  },
  // {
  //   link: ROUTES.DAILY_OPERATIONS,
  //   icon: <DailyOperations />,
  //   text: "Daily Operations",
  //   // activeIcon: <DailyOperations />
  // }
];


export const dailyOpsContent = [
  {
    label: "Prospecting and outreach",
    component: <Outreach className="p-3 my-4"/>
  },
  {
    label: "Bidding Stage",
    component: <Bidding className="p-3 my-4" />

  },
  {
    label: "Onboarding Stage",
    component: <OnBoarding className="p-3 my-4" />
  },
  {
    label: "Project Execution",
    component: <Project className="p-3 my-4" />
  }
]